module.exports = __webpack_public_path__ + "240b3961d4e64a4a7ca3242d9293ed3b.svg";